import { usePageTracking } from './use-page-tracking';

export function PageTracking() {
	usePageTracking();

	return null;
}